import React, { useEffect, useState } from "react";
import {
  useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import * as Constant from "../../features/constant";
import { ThemeConsumer } from "styled-components";

export default function GameLauncher() {
  const location = useLocation();
  const [gameUrl, setGameUrl] = useState("");
  const navigate = useNavigate();
  const backUrl = location.state?.backUrl;
  const theme = useTheme();

  useEffect(() => {
    const raw = window.location.search;
    if (raw.startsWith("?url=")) {
      const fullUrl = raw.substring(5); // remove "?url="
      setGameUrl(fullUrl);
    }
  }, []);

  useEffect(() => {
    const setHeight = () => {
      document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    setHeight();
    window.addEventListener("resize", setHeight);
    return () => window.removeEventListener("resize", setHeight);
  }, []);

  // const goBack = () => {
  //   if (window.history.length > 1) {
  //     // Listen for the navigation to the previous page
  //     const handlePopState = () => {
  //       // Reload the page once we arrive
  //       window.location.reload();
  //       // Remove the listener to avoid triggering multiple times
  //       window.removeEventListener("popstate", handlePopState);
  //     };
  
  //     window.addEventListener("popstate", handlePopState);
  
  //     // Go back
  //     window.history.back();
  //   } else {
  //     // No previous page in history, fallback to home
  //     window.location.href = "/";
  //   }
  // };

  const goBack = () => {
    const prevPage = sessionStorage.getItem("prevPageBeforeGame") || "/";
  window.location.href = prevPage;
  }
  return (
    <div style={{ margin: 0, padding: 0, height: "var(--app-height, 100vh)", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      {/* HEADER — uses fixed 8vh height to match previous iframe header */}
      <header className="kw-header">
        <div className="container">
          <img
            src={process.env.REACT_APP_LOGO}
            alt="logo"
            className="logo"
            onClick={() => {
                navigate(Constant.getPath("/"));
              }}
          />

          <div className="button-container">
            <button
              className="deposit-btn"
              onClick={() => {
                navigate(Constant.getPath("/profileWallet"),
                  {
                  state: {
                    screen: 'deposit'
                    }
                  }
                );
              }}
            >
              DEPOSIT
            </button>

            <button className="close-btn" onClick={goBack}>
              X
            </button>
          </div>
        </div>
      </header>

      {/* GAME IFRAME */}
      <iframe
        id="gameIframe"
        src={gameUrl}
        title="game"
        frameBorder="0"
        style={{ width: "100%", flex: 1, display: "block", border: "none", minHeight: 0 }}
      />

      {/* Styles: mirrors your original CSS but tuned so button sizes match the screenshot */}
      <style>{`
        /* header is 8% of viewport height to match the original header iframe */
        .kw-header {
          height: 8vh;
          width: 100%;
          box-sizing: border-box;
        }

        .container {
          width: 100%;
          height: 100%;
          background-color: black; 
          ${process.env.REACT_APP_HEADER_IMAGE ? `background: url('${process.env.REACT_APP_HEADER_IMAGE}') no-repeat left center;` : ''}
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          height: 80%;
          margin-left: 30px;
          cursor: pointer;
        }

        .button-container {
          display: flex;
          align-items: center;
          align-self: center;
        }

        /* tuned font-sizes so they visually match the screenshot when header is 8vh */
        .deposit-btn {
          background: ${theme.palette.button.secondary.main};
          padding: 10px 18px 10px ;
          margin-right: 25px;
          border-radius: 4px;
          color: white;
          font-family: Verdana, Geneva, sans-serif;
          font-size: 1.8vh;    /* tuned from huge vh to a value that matches original look */
          line-height: 1;
          border: none;
          cursor: pointer;
          height: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
        }

        .close-btn {
          color: white;
          background: transparent;
          border: none;
          font-family: Verdana, Geneva, sans-serif;
          font-size: 2.8vh;    /* tuned so the X is larger than DEPOSIT like the screenshot */
          margin-right: 30px;
          cursor: pointer;
          height: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 8px;
        }

        /* responsive */
        @media screen and (max-width: 600px) {
          .logo {
            height: 60%;
            margin-left: 20px;
          }
          .deposit-btn {
            margin-right: 15px;
            font-size: 1.6vh;
            padding: 10px 18px 10px ;
          }
          .close-btn {
            font-size: 2.6vh;
            margin-right: 15px;
          }
        }
      `}</style>
    </div>
  );
}
